import * as React from 'react';
import Switch from '@material-ui/core/Switch';
import { Parameter } from 'shapediver-types';
import { useCallback, useState } from 'react';

type ParameterDefinition = Parameter.ParameterDefinition;

type Props = {
  initialValue: boolean;
  definition: ParameterDefinition;
  onChange: (newValue: boolean) => void;
};

const CheckboxInput = (props: Props): React.ReactElement => {
  const { definition, initialValue, onChange } = props;
  const { id } = definition;

  const [value, setValue] = useState(initialValue);

  const onSwitchChange = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>, checked: boolean): void => {
      setValue(checked);
      onChange(checked);
    },
    [onChange]
  );

  return (
    <Switch
      color="primary"
      id={id}
      checked={value}
      onChange={onSwitchChange}
      name={id}
    />
  );
};

export default CheckboxInput;
